import { createSlice } from "@reduxjs/toolkit";
import { makeThunk } from "helpers/makeThunk";
import { handleCommonCases } from "helpers/thunkHandler";
import {
  DOWNLOAD_REPORTS,
} from "helpers/url_helper";

export const downloadTransactionsReports = makeThunk({
  url: `${DOWNLOAD_REPORTS}/transaction`,
  method: "downloadCSV",
});
export const downloadCustomerReports = makeThunk({
  url: `${DOWNLOAD_REPORTS}/customer`,
  method: "downloadCSV",
});

const initialState = {
  downloadingReports: false,
  reportsFilter: {
    reportsOrderBy: -1,
    reportKeyword: "",
    reportDates: [],
    exportType:"csv"
  },
  transactionsExportData: {},
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,

  reducers: {
    setReportFilter: (state, action) => {
      const { key, value } = action.payload;
      state.planFilters[key] = value;
    },

    resetReportFilter: (state) => {
      state.planFilters = initialState.planFilters;
    },
  },

  extraReducers: (builder) => {
    handleCommonCases(builder, downloadTransactionsReports, {
      onPending: (state) => {
        state.downloadingReports =true;
        state.transactionsExportData = {};
      },
      onFulfilled: (state, action) => {
        const { data } = action.payload || {};
        state.downloadingReports =false;
      },
    });
    handleCommonCases(builder, downloadCustomerReports, {
      onPending: (state) => {
        state.downloadingReports =true;
        state.transactionsExportData = {};
      },
      onFulfilled: (state, action) => {
        const { data } = action.payload || {};
        state.downloadingReports =false;
      },
    });
  },
});

export const { setReportFilter, resetReportFilter } = reportsSlice.actions;

export default reportsSlice.reducer;
